var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiconFileDropper = function SvgMiconFileDropper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M25 30a5.005 5.005 0 0 1-5-5V14h2v11a3 3 0 0 0 6 0v-9a1 1 0 0 0-2 0v10h-2V16a3 3 0 0 1 6 0v9a5.005 5.005 0 0 1-5 5M3 3h2v2H3zM3 7h2v2H3zM3 11h2v2H3zM3 15h2v2H3zM3 19h2v2H3zM3 23h2v2H3zM3 27h2v2H3zM7 3h2v2H7zM11 3h2v2h-2zM15 3h2v2h-2zM7 27h2v2H7zM11 27h2v2h-2zM15 27h2v2h-2zM19 3h2v2h-2zM27 3h2v2h-2zM23 3h2v2h-2zM27 7h2v2h-2z"
  })));
};
export default SvgMiconFileDropper;